import React from "react";
import { useTranslation } from "../../i18n";
import { DropdownBox } from "../../dropdown";
import { List } from "../../list";
import { Text } from "../../text";
export var Empty = function (_a) {
    var offset = _a.offset, onCancel = _a.onCancel, emptyText = _a.emptyText;
    var t = useTranslation();
    return (React.createElement(DropdownBox, { style: { marginLeft: offset } },
        React.createElement(List, { type: "option" },
            React.createElement(List.Item, { onClick: onCancel },
                React.createElement(Text, { theme: "label" }, emptyText || t.emptyText)))));
};
//# sourceMappingURL=Empty.js.map